<template>
    <div>
      <div class="card mb-3">
          <div class="row no-gutters" style="min-height: 56vh; overflow: auto;">
            <div class="col-md-3" style="border-right: 1px solid #e0e0e0">
              <div class="card-body">
                <div>
                  <h6 class="heading-small text-muted mb-4">Search</h6>
                  <base-input alternative="" label="Deployment Date"><br>
                    <a-range-picker v-model="dateRange"
                                    format="MM-DD-YYYY"
                                    :placeholder="['Start Date', 'End Date']"
                                    style="width:100%"/>
                  </base-input>
                </div>
                <div>
                  <base-input alternative="" label="OS"><br>
                  <a-select showSearch
                            v-model="selectedOS"
                            placeholder="Select OS"
                            optionFilterProp="children"
                            style="width: 100%">
                    <a-select-option v-for="option in OsOptions"
                                    :key="option.key"
                                    :value="option.key">
                      {{option.value}}
                    </a-select-option>
                  </a-select>
                  </base-input>
                </div>
                <div>
                  <base-input alternative="" label="Type"><br>
                  <a-select showSearch
                            v-model="selectedType"
                            placeholder="Select Type"
                            optionFilterProp="children"
                            style="width: 100%">
                    <a-select-option v-for="option in OsTypes"
                                    :key="option.key"
                                    :value="option.key">
                      {{option.value}}
                    </a-select-option>
                  </a-select>
                  </base-input>
                </div>
                <div>
                  <button class="float-right btn btn-sm btn-success mr-2" @click="retrieveDeveloperAccounts(1, ''); filterTag = 1"> <span class="fa fa-filter" /> Filter </button>
                </div>
                <br/>
                <hr class="my-4" />
                  <h6 class="heading-small text-muted mb-4">Filter by status</h6>
                  <div>
                      <base-radio name="0" class="mb-3" v-model="filterStatus" value="O">
                          All
                      </base-radio>
                      <base-radio name="D" class="mb-3" v-model="filterStatus" value="D">
                          Deployed
                      </base-radio>
                      <base-radio name="F" class="mb-3" v-model="filterStatus" value="F">
                          For Deployment
                      </base-radio>
                      <base-radio name="P" class="mb-3" v-model="filterStatus" value="P">
                          Pending
                      </base-radio>
                  </div>
              </div>
            </div>
            <div class="col-md-9" >
              <div class="card-body">
                  <div class="ml-2"><h2 class="card-title">POS Versions</h2></div>
                  <a-table :scroll="{ x: 1000 }" size="small" rowKey="id" :columns="columns" :data-source="data" style="min-height: 50vh; overflow: auto;"
                  :pagination="pagination" @change="handleTableChange">
                      <span slot="os" slot-scope="text, record">
                          <div v-if="record.os == 'W'">WINDOWS</div>
                          <div v-if="record.os == 'L'">LINUX</div>
                          <div v-if="record.os == 'M'">MAC</div>
                      </span>
                      <!-- <span slot="accounts" slot-scope="text, record">
                          <a-tag color="orange">{{record.accounts}}</a-tag>
                      </span> -->
                      <span slot="accounts" slot-scope="text, record">
                        <template v-if="Array.isArray(record.accounts)">
                          <a-tag v-for="(acc, index) in record.accounts" :key="index" color="orange">
                            {{ acc }}
                          </a-tag>
                        </template>
                        <template v-else>
                          <a-tag color="orange">{{ record.accounts }}</a-tag>
                        </template>
                      </span>
                      <span slot="update_type" slot-scope="text, record">
                          <div v-if="record.update_type == 'H'">HOTFIX</div>
                          <div v-if="record.update_type == 'S'">SCHEDULED</div>
                      </span>
                      <span slot="version" slot-scope="text, record">
                          <a-tag v-if="record.status == 'D'" color="green">{{record.version}}</a-tag>
                          <a-tag v-if="record.status == 'P'" color="red">{{record.version}}</a-tag>
                          <a-tag v-if="record.status == 'F'" color="blue">{{record.version}}</a-tag>
                      </span>
                      <span slot="status" slot-scope="text, record">
                          <a-tag v-if="record.status == 'D'" color="green">Deployed</a-tag>
                          <a-tag v-if="record.status == 'P'" color="red">Pending</a-tag>
                          <a-tag v-if="record.status == 'F'" color="blue">For Deployment</a-tag>
                      </span>
                      <span slot="action" slot-scope="text, record">
                        <center>
                          <a-dropdown>
                            <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                              <i class="fa fa-ellipsis-v"></i>
                            </a>
                            <a-menu slot="overlay">
                              <template>
                                <a-menu-item>
                                  <button class="btn btn-info btn-sm" @click.prevent="$emit('changePosRelease', record.id + '|V')">
                                    &nbsp;&nbsp;View&nbsp;&nbsp;
                                  </button>
                                </a-menu-item>
                                <a-menu-item v-if="['F', 'P', 'D'].includes(record.status)">
                                  <button class="btn btn-warning btn-sm" @click.prevent="$emit('changePosRelease', record.id + '|U')">
                                    &nbsp;&nbsp;Edit&nbsp;&nbsp;
                                  </button>
                                </a-menu-item>
                                <a-menu-item v-if="['F', 'P'].includes(record.status)">
                                  <button class="btn btn-success btn-sm">
                                    <a-popconfirm
                                        :title="'You are about to deploy POS version ' + record.version + '?'"
                                        @confirm="deployPosUpdate(record.id)"
                                        okText="Deploy"
                                        cancelText="Cancel"
                                        >Deploy</a-popconfirm
                                    >
                                  </button>
                                </a-menu-item>
                                <a-menu-item v-if="record.status.includes('D')">
                                  <button class="btn btn-success btn-sm" @click.prevent="openDrawerStats(record.id)">
                                    Stats
                                  </button>
                                </a-menu-item>
                                <a-menu-item v-if="['F', 'P', 'D'].includes(record.status)">
                                  <a-popconfirm title="You are about to delete this record?"
                                    @confirm="deleteRow(record.id)" okText="Delete" cancelText="Cancel">
                                    <a class="btn btn-danger btn-sm text-white m-0 p-1">Delete</a>
                                  </a-popconfirm>
                                </a-menu-item>
                              </template>
                            </a-menu>
                          </a-dropdown>
                        </center>
                      </span>
                      <span slot="deployed_at" slot-scope="text, record">
                          {{deployAt(record.deployed_at)}}
                      </span>
                  </a-table>
              </div>
            </div>
          </div>
      </div>
      <a-drawer v-if="drawerVisibleStats" title="" :width="480" placement="right" @close="onCloseStats" :visible="drawerVisibleStats">
        <div>
                <h6 class="heading-small text-muted pb-3">POS version deployment statistics</h6>
                
        </div>
      </a-drawer>
    </div>

</template>

<script>
import HTTPRequest from '../../controllers/httpRequest.js'
import secureStorage from '../../controllers/secureStorage.js'
import { mapState, mapActions } from 'vuex'
import moment from 'moment';

const columns = [
  {
    title: '',
    scopedSlots: { customRender: 'action' },
    fixed: "left",
    align: "center",
  },
  {
    title: 'OS',
    dataIndex: 'os',
    fixed: 'left',
    scopedSlots: { customRender: 'os' },
  },
  {
    title: 'Account',
    dataIndex: 'accounts',
    fixed: 'left',
    scopedSlots: { customRender: 'accounts' },
  },
  {
    title: 'Version',
    dataIndex: 'version',
    scopedSlots: { customRender: 'version' },
  },
  {
    title: 'Status',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: 'Type',
    dataIndex: 'update_type',
    ellipsis: true,
    scopedSlots: { customRender: 'update_type' },
  },
  {
    title: 'Deployed At',
    dataIndex: 'deployed_at',
    scopedSlots: { customRender: 'deployed_at' },
  },
  {
    title: 'Statistics',
    dataIndex: 'statistics',
    ellipsis: true,
  },
  
];

export default {
  mounted: async function(){  
    
  },
  computed: {
       ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
       pagination() {
        return {
          current: this.currentPage,
          pageSize: this.perPage,
          total: this.total,
          showSizeChanger: false,
          simple: false,
          showLessItems: false,
          showQuickJumper: false
        }
      }
  },
  watch: {
    filterStatus: function() {
      this.retrieveDeveloperAccounts(null, this.filterStatus)
      this.filterText = ''
    },
    total(val) {
      console.log('TOTAL FROM API:', val)
    }
  },
  data () {
    return {
        currentPage: 1,
        perPage: 10,
        total: 0,
        drawerVisibleStats: false,
        filterTag: 0,
        selectedOS: 'A',
        selectedType: 'A',
        dateRange: [moment().startOf('day'), moment().endOf('day')],
        selectedProfile: "pos_releases",
        columns,
        data: [],
        userCode: secureStorage.getItem("userCode"),
        filterStatus: '0',
        searchFilter: "name",
        placeholder: "Search by name",
        filterText: '',
        OsOptions : [
            {key: 'A', value: 'All'},
            {key: 'W', value: 'Windows'},
            {key: 'L', value: 'Linux'},
            {key: 'M', value: 'Mac'}
        ],
        OsTypes : [
            {key: 'A', value: 'All'},
            {key: 'H', value: 'Hotfix'},
            {key: 'S', value: 'Scheduled'}
        ],
    }
  },
  mounted: async function(){
    this.retrieveDeveloperAccounts()
  },
  methods: {
    handleTableChange(pagination) {
      if (pagination.current !== this.currentPage) {
        this.currentPage = pagination.current
        this.perPage = pagination.pageSize
        this.retrieveDeveloperAccounts(this.search, this.filterStatus)
      }
    },
    onCloseStats(){
       this.drawerVisibleStats = false
    },
    openDrawerStats(id){
       this.drawerVisibleStats = true
    },
    deployAt(deployed_at) {
      return moment(deployed_at).format('MMM DD, YYYY hh:mm A')
    },
    async deployPosUpdate(id){
      var posRelease = await HTTPRequest.postRequest(this.endPoint + 'pos_releases/update_pos_update?id=' + id , null, null)
      if(posRelease.error == undefined){
          this.$notification['success']({
          message: 'Deployment Success',
          description: "POS version has been deployed accordingly. "
          });
          this.posRelease  = posRelease
          if(this.filterTag == 1)
            this.retrieveDeveloperAccounts(1, '');
          else
            this.retrieveDeveloperAccounts();
      } else {
          this.$notification['error']({
          message: 'Deployment Error',
          description: posRelease.error
          });
      }
    },
    filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    async retrieveDeveloperAccounts(search, status) {
      const page = this.currentPage
      const perPage = this.perPage

      let baseUrl = `${this.endPoint}pos_releases/get_pos_releases?page=${page}&per_page=${perPage}`
      let url = baseUrl
      if (!search && (!status || status === '0')) {
        // insert filter here...
      }
      else if (search && !status) {
        let filters = `&os=${this.selectedOS}`
        filters += `&update_type=${this.selectedType}`
        filters += `&status=${this.filterStatus}`
        filters += `&from=${this.dateRange[0].format('YYYY-MM-DD')}`
        filters += `&to=${this.dateRange[1].format('YYYY-MM-DD')}`
        url += filters
      }
      else if (status) {
        let filters = `&os=${this.selectedOS}`
        filters += `&update_type=${this.selectedType}`
        filters += `&status=${this.filterStatus}`
        filters += `&from=${this.dateRange[0].format('YYYY-MM-DD')}`
        filters += `&to=${this.dateRange[1].format('YYYY-MM-DD')}`
        url += filters
        url += `&status=${status}`
      }

      // const res = await HTTPRequest.getRequest(url, null)
      const res = await HTTPRequest.getRequest(url, null, "BXI-File")
      if (res) {
        this.data = res.data
        this.total = res.total
        this.currentPage = res.current_page
        this.perPage = res.per_page
      }
    },
    notify(action){
      this.$notification['success']({
          message: 'Developer Account',
          description: "Success " + action + " account"
      });
    },
    async approve(record) {
      var developer_account_payload = {"status": "A", "approved_by": this.userCode, "updated_by": this.userCode}
      var developer_account = await HTTPRequest.putRequest(this.endPoint + 'pos_releases/'+record.id, null, developer_account_payload)
      if (developer_account.status == 'A') {
        this.notify('approving');
      }
      this.retrieveDeveloperAccounts();
      this.$parent.retrieveStatistics();
    },
    async activate(record) {
      var developer_account_payload = {"status": "A", "updated_by": this.userCode}
      var developer_account = await HTTPRequest.putRequest(this.endPoint + 'pos_releases/'+record.id, null, developer_account_payload)
      if (developer_account.status == 'A') {
        this.notify('activating');
      }
      this.retrieveDeveloperAccounts();
      this.$parent.retrieveStatistics();
    },
    async deactivate(record) {
      var developer_account_payload = {"status": "D", "updated_by": this.userCode}
      var developer_account = await HTTPRequest.putRequest(this.endPoint + 'pos_releases/'+record.id, null, developer_account_payload)
      if (developer_account.status == 'D') {
        this.notify('deactivating');
      }
      this.retrieveDeveloperAccounts();
      this.$parent.retrieveStatistics();
    },
    setCurrentProfile(profile){
      this.selectedProfile = profile
    },
    changeSearchFilter(searchFilter){
      this.searchFilter = searchFilter
      this.placeholder = "Search by " + searchFilter
    },
    doFilter(){
      this.retrieveDeveloperAccounts(this.filterText, null)
    },
    refresh() {
      if (this.filterTag === 1) {
        this.retrieveDeveloperAccounts(1, '');
      } else {
        this.retrieveDeveloperAccounts();
      }
    },
    async deleteRow(id) {
      var destroy_request = await HTTPRequest.postRequest(this.endPoint + 'pos_releases/destroy_pos_update?id=' + id, null, null)
      if (!destroy_request.error) {
        this.$notification['success']({
          message: 'Delete Success',
          description: 'The record has been deleted successfully.'
        });
        this.refresh(); 
      } else {
        this.$notification['error']({
          message: 'Delete Failed',
          description: destroy_request.error
        });
      }      
    },
  },
}
</script>

<style>
</style>


